export default __webpack_public_path__ + "static/SuccessStoriesMining-4fd82c0c6259fefb8d2711bbb1df4fe7.png";